export const GoogleFormsIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 48 48" width="64" height="64">
    <path fill="#673ab7" d="M37 45H11a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h19l11 11v27a4 4 0 0 1-4 4" />
    <path fill="#d1c4e9" d="M40 14H30V4z" />
    <path fill="#512da8" d="M30 14h10v1l-11-1" />
    <circle fill="#ede7f6" cx="17" cy="24" r="2" />
    <circle fill="#ede7f6" cx="17" cy="31" r="2" />
    <circle fill="#ede7f6" cx="17" cy="38" r="2" />
    <path fill="#ede7f6" d="M22 23h10v2H22zm0 7h10v2H22zm0 7h10v2H22z" />
  </svg>
);
